import { getInputIdFormContext } from '@/utils';
import { Controller, useFormContext } from 'react-hook-form';

import ComboBoxWithLogo, { type InterfaceSelectedValue, type optType } from './ComboBoxWithLogo';

type PropsPass = Omit<InterfaceSelectedValue, 'options'> & {
  currentId: string;
  options: optType[];
};

export const ComboBoxWithLogoContext = ({
  options,
  currentId,
  fieldError,
  ...defaultRes
}: PropsPass) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Controller
        control={control}
        name={currentId}
        render={({ field: { onChange: controllerChange, value, ...res } }) => {
          const selectedOption = defaultRes.isMulti
            ? options.filter((opt) => value?.includes(opt.value))
            : options.find((opt) => opt.value == value);
          const currentValue = typeof selectedOption === 'undefined' ? null : selectedOption;

          return (
            <ComboBoxWithLogo
              {...defaultRes}
              options={options}
              value={currentValue}
              onChange={(selectValue) => {
                // se modifica el valor que recibira react hook form
                if (!selectValue) return null;
                if ('value' in selectValue) {
                  controllerChange(selectValue.value);
                  return null;
                }
                controllerChange(selectValue.map((vl) => vl.value));
              }}
              fieldError={getInputIdFormContext(errors, currentId)?.message}
              {...res}
            />
          );
        }}
      />
    </>
  );
};

export default ComboBoxWithLogoContext;
